if (!customElements.get('variant-option-info')) {
  customElements.define(
    'variant-option-info',
    class VariantOptionInfo extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.button = this.querySelector('.variant-option-info__button');
        // Never name this property "popover": HTMLElement.prototype.popover is a
        // native reflected accessor, and assigning to it sets a popover attribute
        // on this element, which the UA stylesheet then display:none's.
        this.panel = document.getElementById(this.button?.getAttribute('aria-controls'));
        if (!this.button || !this.panel) return;

        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onDocumentKeyup = this.onDocumentKeyup.bind(this);

        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          this.isOpen ? this.close() : this.open();
        });

        this.panel.querySelector('.variant-option-info__close')?.addEventListener('click', () => this.close(true));
      }

      disconnectedCallback() {
        this.removeDocumentListeners();
      }

      get isOpen() {
        return this.button.getAttribute('aria-expanded') === 'true';
      }

      open() {
        this.button.setAttribute('aria-expanded', 'true');
        this.panel.removeAttribute('hidden');
        // pointerup as well as click: iOS Safari doesn't deliver delegated
        // click events for taps on non-interactive elements.
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('pointerup', this.onDocumentClick);
        document.addEventListener('keyup', this.onDocumentKeyup);

        // On phones the picker sits low in the viewport and the pane opens
        // below the fold, so bring it on-screen. Anchored positioning (not
        // fixed) because Dawn's scroll-trigger animations leave a transform
        // on the product info wrapper that hijacks fixed positioning.
        const rect = this.panel.getBoundingClientRect();
        if (rect.bottom > window.innerHeight || rect.top < 0) {
          const block = rect.height >= window.innerHeight ? 'start' : 'nearest';
          this.panel.scrollIntoView({ behavior: 'smooth', block });
        }
      }

      close(focusButton = false) {
        this.button.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', '');
        this.removeDocumentListeners();
        if (focusButton) this.button.focus();
      }

      removeDocumentListeners() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('pointerup', this.onDocumentClick);
        document.removeEventListener('keyup', this.onDocumentKeyup);
      }

      onDocumentClick(event) {
        if (this.contains(event.target) || this.panel.contains(event.target)) return;
        this.close();
      }

      onDocumentKeyup(event) {
        if (event.key === 'Escape') this.close(true);
      }
    }
  );
}
